import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    gap: 24px;
  `};
`;

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 24px;
  `}
`;

export const Container = styled.div`
  ${({ theme, error }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    background-color: ${theme.v2.colors.neutral.highPure};


    ${error && css`
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: 16px;
      justify-content: center;
      padding: 58px;

      > * {
        align-items: center;
        display: flex;
        justify-content: center;
        margin: 0px;
        max-width: 640px;
        text-align: center;
        width: 100%;
      }
    `}
  `}
`;

export const FirstRow = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 16px 0px 0px 0px;

    @media(max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    flex-direction: row;
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0;

    @media(min-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    white-space: break-spaces;

    > svg{
      margin-right: 6px;
    }

    @media(min-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const BlockTextField = styled.div`
  width: 100%;

  ${({ theme }) => css`
    @media(min-width: ${theme.v2.breakpoints.lg}) {
      max-width: 550px;
    }
  `}
`;

export const BlockTrafic = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${({ theme }) => css`
    @media(min-width: ${theme.v2.breakpoints.lg}) {
      flex-direction: row;
    }
  `}
`;

export const SelectFieldContainer = styled.div`
  ${({ theme }) => css`
    @media(min-width: ${theme.v2.breakpoints.lg}) {
      min-width: 400px;
    }
  `}
`;

export const BlockRuleInputContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  ${({ theme }) => css`
    @media(min-width: ${theme.v2.breakpoints.lg}) {
      flex-direction: row;
    }
  `}
`;

export const BlockRuleInput = styled.div`
  flex: 1;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  width: 100%;

  ${({ theme }) => css`
    @media(min-width: ${theme.v2.breakpoints.lg}) {
      max-width: 120px;
    }
  `}
`;

export const TableRow = styled.tr`
  ${({ theme, $lastRow }) => css`
    ${!$lastRow && css`
      border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    `};
  `};
`;

export const InfoText = styled.p`
  ${({ theme }) => css`
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `};
`;

export const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 16px;
  table-layout: fixed;
  width: 100%;

  tr td:last-child, tr th:last-child {
    width: 140px;
  }
    
  tr td:first-child, tr th:first-child {
    width: 200px;
  }
`;

export const TableHeader = styled.thead``;

export const TableHead = styled.th`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-weight: ${theme.v2.font.weights.medium};
    padding: 16px 0;
    text-align: left;
  `};
`;

export const MobileList = styled.div`
  display: flex;
  flex-direction: column;
`;
